import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetClientResponse } from '@/types/clientDetailsApiTypes';
import { CLIENT_QUERY_KEY } from '../../consts/client-detail';

export type UseGetClientQueryOptions = {
  clientIdOverride?: string | null;
};

export const useGetClientQuery = (
  onSuccessLoadData?: (data: GetClientResponse) => void,
  options?: UseGetClientQueryOptions
) => {
  const [searchQuery] = useSearchQuery();
  const clientIdFromUrl = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const clientId = options?.clientIdOverride ?? clientIdFromUrl;

  const { doFetch: getClient } = useFetch<void, GetClientResponse>();

  const query = useQuery({
    queryKey: [CLIENT_QUERY_KEY, clientId],
    queryFn: async () => {
      const response = await getClient(`/api/clients/${clientId}`);
      onSuccessLoadData?.(response);
      return response;
    },
    enabled: !!clientId,
    retry: 1,
  });

  return query;
};
